(function (Wishlist, $) {
    var $wishlistButton = $(".wishlist-btn");
    var $wishlistTile = $(".wishlist-tile-container");
    var wishlist = JSON.parse(localStorage.getItem("user_wishlist") || "[]");
    $(".wishlist_count").text(wishlist.length);

    var animateWishlist = function (self) {
        $(self).toggleClass("is-active");
    };

    var updateWishlist = function (self) {
        var productHandle = $(self).attr("data-product-handle");
        if (!productHandle) return;
        var isRemove = $(self).hasClass("is-active");
        if (isRemove) {
            wishlist = wishlist.filter(function (item) {
                return item !== productHandle;
            });
        } else {
            if (!wishlist.includes(productHandle)) {
                wishlist.push(productHandle);
            }
        }
        localStorage.setItem("user_wishlist", JSON.stringify(wishlist));
        if (wishlist.length === 0) {
            $(".wishlist_count").hide();
        } else {
            $(".wishlist_count").text(wishlist.length).show();
        }
    };

    var removeWishlistItem = function (self) {
        var productHandle = $(self).attr("data-product-handle");
        if (!productHandle) return;
        wishlist = wishlist.filter(function (item) {
            return item !== productHandle;
        });
        localStorage.setItem("user_wishlist", JSON.stringify(wishlist));
        if (wishlist.length === 0) {
            $(".wishlist_count").hide();
        } else {
            $(".wishlist_count").text(wishlist.length).show();
        }
        $(self).closest(".wishlist-tile-container").remove();
        if ($(".wishlist-tile-container").length === 0) {
            $(".wishlist-grid--empty-list").addClass("is_visible").show();
        }
    };

    var activateItemsInWishlist = function () {
        $wishlistButton.each(function () {
            var productHandle = $(this).attr("data-product-handle");
            if (wishlist.includes(productHandle)) {
                $(this).addClass("is-active");
            }
        });
    };

    var displayOnlyWishlistItems = function () {
        $wishlistTile.each(function () {
            var productHandle = $(this).attr("data-product-handle");
            if (!wishlist.includes(productHandle)) {
                $(this).remove();
            }
        });
    };

    var loadWishlist = function () {
        if (window.location.href.includes("pages/wishlist")) {
            displayOnlyWishlistItems();

            $(".wishlist-loader").fadeOut(2000, function () {
                $(".wishlist-grid").addClass("is_visible");
                $(".wishlist-hero").addClass("is_visible");

                if ($(".wishlist-tile-container").length === 0) {
                    $(".wishlist-grid--empty-list").addClass("is_visible").show();
                } else {
                    $(".wishlist-grid--empty-list").hide();
                }
            });
        }
    };

    var bindUIActions = function () {
        $wishlistButton.on("click", function (e) {
            e.preventDefault();
            updateWishlist(this);
            animateWishlist(this);
        });

        $(".remove-btn").on("click", function (e) {
            e.preventDefault();
            removeWishlistItem(this);
        });
    };

    Wishlist.init = function () {
        bindUIActions();
        activateItemsInWishlist();
        loadWishlist();
        if (wishlist.length === 0) {
            $(".wishlist_count").hide();
        } else {
            $(".wishlist_count").text(wishlist.length).show();
        }
    };
    })(window.Wishlist = window.Wishlist || {}, jQuery);

      $(document).ready(function () {
          if (window.Wishlist && typeof Wishlist.init === "function") {
              Wishlist.init();
          } else {
              console.error("Wishlist.init is not defined. Ensure Wishlist.js is loaded correctly.");
          }
      
          $(document).on('click', '.custom_product', function (event) {
          event.preventDefault();
          var $button = $(this);
          let productId = $button.data('product-id');
          let getVariantId = $button
              .closest('.product-cart-button')
              .find('#getvariantid')
              .val();
      
          if (!getVariantId) {
              alert('Please select a variant.');
              return;
          }
      
          // Optimization: Removed redundant GET /cart.js check which was blocking valid additions
          // and slowing down the process. Shopify backend handles inventory checks.

          let formObj = {
              quantity: 1,
              id: getVariantId,
              sections: 'cart-drawer,cart-icon-bubble' // Use Section Rendering API
          };

          $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              dataType: 'json',
              cache: false,
              data: formObj,
              success: function (data) {
                  const sections = data.sections;
                  
                  $('.loading__spinner').removeClass('hidden');
                  setTimeout(function () {
                      $('.loading__spinner').addClass('hidden');
                  }, 1000);

                  $button.attr('aria-disabled', 'true');
                  setTimeout(function () {
                      $('body').addClass('overflow-hidden');
                      $('cart-drawer').addClass('active');
                      $button.attr('aria-disabled', 'false');
                  }, 1000);

                  $(document).on('click', '#CartDrawer-Overlay', function () {
                      $('body').removeClass('overflow-hidden');
                      $('cart-drawer').removeClass('active');
                  });

                  $('cart-drawer').removeClass('is-empty');
                  $('.drawer__inner-empty').hide();
                  
                  // Update Cart Drawer
                  if (sections['cart-drawer']) {
                       // Extract the inner content of the section wrapper
                       const cartDrawerHtml = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
                       const cartDrawerLocal = cartDrawerHtml.querySelector('#CartDrawer');
                       if (cartDrawerLocal && $('cart-drawer').find('#CartDrawer').length) {
                           $('cart-drawer').find('#CartDrawer').replaceWith(cartDrawerLocal);
                       } else {
                           // Fallback
                           $('cart-drawer').html(sections['cart-drawer']);
                       }
                  }

                  // Update Cart Icon
                  if (sections['cart-icon-bubble']) {
                      // The section response typically includes the wrapper div, we want the inner content 
                      // or we replace the inner HTML of the anchor.
                      const cartIconHtml = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
                      // The section root usually has id="shopify-section-..."
                      const sectionRoot = cartIconHtml.querySelector('.shopify-section');
                      if (sectionRoot) {
                           $('#cart-icon-bubble').html(sectionRoot.innerHTML);
                      } else {
                           $('#cart-icon-bubble').html(sections['cart-icon-bubble']);
                      }
                  }
              },
              error: function (xhr, status, error) {
                  // Handle "Sold Out" or other errors from clean Shopify API response
                  let errorMessage = 'Error adding product to cart.';
                  if (xhr.responseJSON && xhr.responseJSON.description) {
                      errorMessage = xhr.responseJSON.description;
                  }
                   $button
                      .closest('.product-cart-button')
                      .find('.product-form__error-message')
                      .remove();
                  $button
                      .closest('.product-cart-button')
                      .append(
                          `<span class="product-form__error-message"><svg class="icon icon-error" viewBox="0 0 13 13"><circle cx="6.5" cy="6.5" r="5.5" stroke="#fff" stroke-width="2"/><circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width=".7"/><path fill="#fff" d="m5.874 3.528.1 4.044h1.053l.1-4.044zm.627 6.133c.38 0 .68-.288.68-.656s-.3-.656-.68-.656-.681.288-.681.656.3.656.68.656"/><path fill="#fff" stroke="#EB001B" stroke-width=".7" d="M5.874 3.178h-.359l.01.359.1 4.044.008.341h1.736l.008-.341.1-4.044.01-.359H5.873Zm.627 6.833c.56 0 1.03-.432 1.03-1.006s-.47-1.006-1.03-1.006-1.031.432-1.031 1.006.47 1.006 1.03 1.006Z"/></svg> ${errorMessage}</span>`
                      );
                  console.error('Failed to update cart:', error);
              },
          });
      });

    $(document).on('change', '#getvariantid', function () {
        let selectedVariantId = $(this).val();
        let productContainer = $(this).closest('.product-tile-container');
        let productHandle = productContainer.data('product-handle');

        $.ajax({
            url: `/products/${productHandle}.js?timestamp=${new Date().getTime()}`,
            method: 'GET',
            dataType: 'json',
            success: function (product) {
                let selectedVariant = product.variants.find(variant => variant.id == selectedVariantId);
                let imageSrc = selectedVariant && selectedVariant.featured_image
                    ? selectedVariant.featured_image.src
                    : product.featured_image.src;

                let imageAlt = selectedVariant ? selectedVariant.name : product.title;

                productContainer
                    .find('.image--main')
                    .attr('src', imageSrc)
                    .attr('alt', imageAlt);

                let $addToCartButton = productContainer.find('.custom_product');
                if (selectedVariant && !selectedVariant.available) {
                    $addToCartButton.prop('disabled', true).text('Sold Out');
                } else {
                    $addToCartButton.prop('disabled', false).text('Add to Cart');
                }
            },
            error: function (xhr, status, error) {
                console.error('Error fetching product data:', error);
            },
        });
    });
});
